<template>
  <div>
    <div class="index_intro_image"><img src="../../assets/index_intro/index_intro.jpg"><img src="../../assets/index_intro/index_intro_sm.jpg"></div>
    <div class="container index_intro">
      <div class="index_intro_content">
        <h2>時代至上的串聯 專業｜創意｜實力</h2>
        <p>上聯國際展覽有限公司成立於1994年，至今已策劃超過1500場展覽，年逾50場展覽的經驗，為台灣展覽規模首屈一指的專業策展公司。主要服務項目為承辦國內外各類型展覽，及展覽徵展業務、議題創意、媒體公關、展覽顧問、整合行銷規劃、國際策展交流等。專業、創意、實力：堅持以「專業」展覽的Know-How、國際接軌的「創意」思維，及展覽執行的「實力」，貼近參展企業、民眾及消費通路的多元服務需求，為客戶提供全方位的展覽解決方案。</p>
      </div>
      <div class="index_intro_target">
        <div class="target_item" v-for="item in introIcons" :key="item.title">
          <div><img :src="item.iconUrl"></div>
          <div>
            <h3 v-html="item.title"></h3>
            <p style="font-weight: bold;color:#00a0e9;" v-html="item.content"></p>
            <p v-html="item.sub_content"></p>
          </div>
        </div>
      </div>
    </div>
    <moreButton button_text="了解更多" button_href="about"></moreButton>
  </div>
</template>

<script>
import MoreButton from '@/components/index/MoreButton'

export default {
  name: 'indexIntro',
  props: {},
  data () {
    return {
      introIcons: [
        {title: '關於我們', iconUrl: require('../../assets/index_intro/index_intro_sm02.jpg'), content: '精緻生活的產業 人文品味的內涵 優質專業的服務', sub_content: '上聯國際展覽成立於1994年，以提供美好生活品味的展覽而努力。25年來，在全國各展覽中心，規劃出婚紗廣場、婦幼百貨、設計空間、自然造景、品牌名店、精緻餐飲以及藝文環境，讓消費者以感受生命中各種產業之美。'},
        {title: '合作夥伴', iconUrl: require('../../assets/index_intro/index_intro_sm05.jpg'), content: '多元通路連結 與各公、協會及政府單位合作', sub_content: '合作夥伴：TCDA台灣咖啡發展協會、TICA 與貓共舞俱樂部、中華民國茶商業同業公會全國聯合會、中華民國資訊軟體協會、中華民國電器商業同業公會全國聯合會、中華民國對外貿易發展協會、中華會展經貿促進協會、台北市汽車代理商業同業公會、台北市旅行商業同業公會、台北市電器商業同業公會會、台灣區家具工業同業公會、台灣區教育用品工業同業公會、台灣陶瓷工業同業公會、台灣綠建材產業發展協會、社團法人台灣永續綠營建聯盟、社團法人台灣連鎖加盟促進協會、高雄市旅行商業同業公會、臺灣農業生技學會、聯合報系經濟日報…等單位'},
        {title: '展覽類型', iconUrl: require('../../assets/index_intro/index_intro_sm01.jpg'), content: '深耕產業展覽<br>行銷各大品牌', sub_content: '上聯國際展覽公司，每年在台灣北中南各地有超過60檔展覽，打造出豐富多元的產業鏈，服務台灣上千家在地產業，每年吸引近千萬人次觀展。'},
        {title: '策展團隊', iconUrl: require('../../assets/index_intro/index_intro_sm04.jpg'), content: '全方位行銷策展團隊<br>&nbsp;', sub_content: '深入了解客戶產業、熟知相關領域知識-業務部源源不絕的創意且完整掌握行銷策略-企劃部'},
        {title: '願景', iconUrl: require('../../assets/index_intro/index_intro_sm03.jpg'), content: '開創行業新格局<br>促進台灣產業經濟發展', sub_content: '透過各界合作將展覽品牌化，活絡並為各產業打造標竿，藉此擴大產值、帶動社會經濟，追求各行業的永續發展。'}
      ]
    }
  },
  components: {
    'moreButton': MoreButton
  }
}
</script>

<style lang="sass">
$pc-992-media: '992px'
$pad-768-media: '768px'
$mobile-576-media: '576px'

@mixin pc-width() 
  @media (max-width: $pc-992-media)
    @content

@mixin pad-width() 
  @media (max-width: $pad-768-media)
    @content

@mixin mobile-width() 
  @media (max-width: $mobile-576-media)
    @content

.index_intro_image
  max-width: 1140px
  margin: auto
  img 
    &:first-child
      display: block
      width: 100%
    &:last-child 
      display: none
      width: 100%
  @include pad-width 
    img:first-child
      display: none
    img:last-child
      display: block
  
.index_intro
  .index_intro_content
    h2 
      margin-top: 60px
      text-align: center
    p 
      text-align: center
      line-height: 1.6
      color: grey
      padding: 0 40px
      margin-top: 30px
  .index_intro_target
    display: flex
    justify-content: space-around
    align-items: flex-start
    margin-top: 50px
    .target_item
      width: 20%
      div:nth-child(1)
        height: 113px
        display: flex
        align-items: center
        justify-content: center
      div:nth-child(2)
        padding: 0 20px
        border-right: 1px solid #00a0e9
      &:last-child 
        div:nth-child(2)
          border-right: none
    img 
      display: block
    h3 
      text-align: center
      color: #00a0e9
    p 
      text-align: center
      font-size: 14px
      color: grey
      &:nth-child(3) 
        position: relative
        height: 2rem
        text-overflow: ellipsis
        white-space: normal
        overflow: hidden
        display: -webkit-box
        -webkit-line-clamp: 2
        -webkit-box-orient: vertical
        &::after 
          background: linear-gradient(to right, rgba(255, 255, 255, 0), #FFFFFF 70%) repeat scroll 0 0 rgba(0, 0, 0, 0)
          bottom: 0
          content: "..."
          padding: 0 5px 1px 30px
          position: absolute
          right: 0
  @include pc-width
    .index_intro_target
      flex-flow: row wrap
      .target_item
        width: 50%
        margin-top: 20px
        div:nth-child(2)
          border-right: none
  @include pad-width
    .index_intro_content
      p
        padding: 0 20px
    .index_intro_target
      .target_item
        width: 100%
  @include mobile-width
    .index_intro_content
      h2 
        font-size: 21px
        margin-top: 20px
      p 
        text-align: justify
        font-size: 15px
        padding: 0 10px
        margin-top: 30px
    .index_intro_target 
      margin-top: 10px
      .target_item
        p 
          width: 200px
          margin: 13px auto
</style>
